import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../store"
import OldUIContext from "../../olduicontext"

import { initialize, requestExample } from "./actions"

import Export from "./components/export/Export"
import Import from "./components/import/Import"
import { IOldUIContext } from "../../global"

interface exportMethods {
    generateConfiguration: () => void
    generateExampleConfiguration: () => void
}

interface OldUIInit {
    startExport: () => void
    startImport: () => void
    export: exportMethods
}

function init(store: AppStore, oldUIContext: IOldUIContext): OldUIInit {
    const startExport = (): void => {
        const element = document.getElementById("newui-deployment-export")
        store.dispatch(initialize("EXPORT"))

        if (element) {
            const root = createRoot(element)
            root.render(
                <Provider store={store}>
                    <OldUIContext.Provider value={oldUIContext}>
                        <OldUIContext.Consumer>
                            {(): JSX.Element => <Export />}
                        </OldUIContext.Consumer>
                    </OldUIContext.Provider>
                </Provider>,
            )
        }
    }

    const startImport = (): void => {
        const element = document.getElementById("newui-deployment-import")
        store.dispatch(initialize("IMPORT"))

        if (element) {
            const root = createRoot(element)
            root.render(
                <Provider store={store}>
                    <OldUIContext.Provider value={oldUIContext}>
                        <OldUIContext.Consumer>
                            {(): JSX.Element => <Import />}
                        </OldUIContext.Consumer>
                    </OldUIContext.Provider>
                </Provider>,
            )
        }
    }

    const generateConfiguration = (): void => {
        store.dispatch(requestExample(true))
    }

    const generateExampleConfiguration = (): void => {
        store.dispatch(requestExample(false))
    }

    return {
        startExport,
        startImport,
        export: {
            generateConfiguration,
            generateExampleConfiguration,
        },
    }
}

export default init
